var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.5C3.55109 16.5 3.36032 16.421 3.21967 16.2804C3.07902 16.1397 3 15.9489 3 15.75V2.25003C3 2.05112 3.07902 1.86035 3.21967 1.7197C3.36032 1.57905 3.55109 1.50003 3.75 1.50003H14.25C14.4489 1.50003 14.6397 1.57905 14.7803 1.7197C14.921 1.86035 15 2.05112 15 2.25003V4.50003H13.5V3.00003H4.5V15H13.5V13.5H15V15.75C15 15.9489 14.921 16.1397 14.7803 16.2804C14.6397 16.421 14.4489 16.5 14.25 16.5H3.75ZM13.5 12V9.75003H8.25V8.25003H13.5V6.00003L17.25 9.00003L13.5 12Z",
    fill: "#262B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2c79012e.svg";
export { ForwardRef as ReactComponent };